import React, { useEffect, useState } from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ChevronLeftIcon } from "../../../assets/icons/chevron-left.svg";
import { useDispatch, useSelector } from "react-redux";
import { patientLogic } from "../../../store/features/patient/patientSlice";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import PatientLoader from "../../common/PatientLoader";
import { Helmet } from "../../common/Helmet";
import { ReactComponent as SearchIcon } from "../../../assets/icons/Search.svg";
import { ReactComponent as ClearCrossIcon } from "../../../assets/icons/ClearCross.svg";
import { ReactComponent as SortArrowIcon } from "../../../assets/icons/SortArrow.svg";
import { getInitials } from "../../../util/helpers";

const CareMembers = () => {
  const dispatch = useDispatch();
  const { user, staffData } = useSelector((state) => state.app);
  const navigate = useNavigate();
  const { loading, patientData } = useSelector((state) => state.patient);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortedData, setSortedData] = useState([...staffData]);
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortBy, setSortBy] = useState("");

  const handleNavigation = (navigate_to) => {
    navigate(navigate_to);
  };
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);

    const filteredData = staffData.filter((item) =>
      (item.first_name + item.last_name)
        .toLowerCase()
        .includes(event.target.value.toLowerCase())
    );
    setSortedData(filteredData);
  };
  const handleSort = (columnName) => {
    const newSortDirection =
      columnName === sortBy
        ? sortDirection === "asc"
          ? "desc"
          : "asc"
        : "asc";
    const sorted = [...sortedData].sort((a, b) => {
      if (a[columnName] < b[columnName]) return -1;
      if (a[columnName] > b[columnName]) return 1;
      return 0;
    });
    if (newSortDirection === "desc") {
      sorted.reverse();
    }
    setSortDirection(newSortDirection);
    setSortedData(sorted);
    setSortBy(columnName);
  };
  const getSortIcon = (key) => {
    if (sortBy === key) {
      return sortDirection === "asc" ? (
        <SortArrowIcon style={{ marginLeft: "5px" }} />
      ) : (
        <SortArrowIcon
          style={{ transform: "rotate(180deg)", marginLeft: "5px" }}
        />
      );
    }
    return <SortArrowIcon style={{ marginLeft: "5px" }} />;
  };
  useEffect(() => {
    dispatch(
      patientLogic({
        page_size: 999999,
        page: 1,
        clinic_id: user?.clinic?.id,
        clinician_id: user?.id,
      })
    );
  }, [user]);

  const getPatientCountbyID = (id) => {
    let count = 0;

    patientData?.forEach((patient) => {
      if (patient.clinician === id) {
        count++;
      }
    });
    return count;
  };

  return (
    <SidebarLayout>
      <>
        <div className="row col-sm-12 col-md-12 col-lg-12">
          <div className="p-4 flex justify-between">
            <button
              style={{ display: "inline" }}
              class="btn"
              title="back to dashboard"
              onClick={() => handleNavigation("/aco/home")}
            >
              <i>
                {" "}
                <ChevronLeftIcon />
              </i>
            </button>
            <h4
              style={{
                textAlign: "left",
                display: "inline-block",
                position: "relative",
              }}
            >
              Team Members
            </h4>
          </div>
        </div>

        <div
          className="d-flex m-5"
          style={{
            gap: "5px",
            width: "fit-content",
            borderBottom: "1px solid lightgray",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SearchIcon />
          <div
            className="d-flex"
            style={{
              gap: "5px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              value={searchQuery}
              onChange={handleSearchChange}
              placeholder={`Search by Name`}
              style={{
                border: "none",

                borderRadius: "0px",
                backgroundColor: "transparent",
                width: "15rem",
              }}
            />
            <ClearCrossIcon
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSearchQuery("");
                setSortedData([...staffData]);
              }}
            />
          </div>
        </div>

        <CardLayout
          className="col-sm-12 col-md-12 col-lg-12"
          style={{
            border: "8px solid transparent",
            boxSizing: "border-box",
            backgroundClip: "padding-box",
          }}
        >
          <table className="table my-3 px-2">
            <thead
              className="thead-light"
              style={{ backgroundColor: "#F9FAFB" }}
            >
              <tr
                style={{
                  height: "4rem",
                  verticalAlign: "middle",
                }}
              >
                <th scope="col">
                  <span
                    className="muted-text"
                    onClick={() => handleSort("first_name")}
                    style={{ cursor: "pointer" }}
                  >
                    NAME
                  </span>
                  {getSortIcon("first_name")}
                </th>
                <th scope="col">
                  <span
                    className="muted-text"
                    onClick={() => handleSort("role")}
                    style={{ cursor: "pointer" }}
                  >
                    ROLE
                  </span>
                  {getSortIcon("role")}
                </th>
                <th scope="col">
                  <span className="muted-text">USERNAME</span>
                </th>
                <th scope="col">
                  <span className="muted-text">No. OF PATIENT</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData?.map((val, key) => {
                return (
                  <tr key={key}>
                    <td>
                      <div
                        className="container d-flex "
                        style={{
                          alignItems: "center",
                        }}
                      >
                        <img
                          className="px-2"
                          alt="User's avatar"
                          style={{ height: "40px", borderRadius: "100%" }}
                          src={`https://placehold.co/70x70/f1f1f5/395E9D/?text=${getInitials(
                            val?.first_name + " " + val?.last_name
                          )}`}
                        />
                        {val?.first_name + " " + val?.last_name}
                      </div>
                    </td>
                    <td>{val?.role}</td>
                    <td>{val?.username}</td>
                    <td>
                      {val?.role === "CLINIC_ADMIN" ||
                      user?.role === "CLINICAL_STAFF"
                        ? getPatientCountbyID(val.id)
                        : "N/A"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </CardLayout>
      </>
    </SidebarLayout>
  );
};

export default CareMembers;
